import { useGetAllPersonalityQuestions } from "@/api/question/useGetAllPersonalityQuestions";
import { useEffect, useRef, useState } from "react";

const STORAGE_KEY = "adminQuestionFilter";

export function useQuestionFilter() {
  const { data: questionsData } = useGetAllPersonalityQuestions();
  const [selectedQuestionIds, setSelectedQuestionIds] = useState<number[]>([]);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only initialize once when questionsData becomes available
    if (hasInitialized.current || !questionsData?.questions) return;

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setSelectedQuestionIds(JSON.parse(stored));
      } catch (error) {
        console.error("Failed to parse adminQuestionFilter from localStorage", error);
      }
    } else {
      const allIds = questionsData.questions.map((q) => q.id);
      setSelectedQuestionIds(allIds);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(allIds));
    }

    hasInitialized.current = true;
  }, [questionsData]);

  const updateFilter = (ids: number[]) => {
    setSelectedQuestionIds(ids);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  };

  return {
    selectedQuestionIds,
    updateFilter,
  };
}
